export const DRAWER_WIDTH = 280;
export const APP_BAR_HEIGHT = 64;
